<template>
  <div>
    <b-navbar toggleable class="mobile-navbar" :style="companyDynamicStyle">
      <!-- NAVBAR COMPANY LOGO -->
      <div class="d-flex">
        <div class="company-brand" @click="homeRedirection">
          <img
            :src="companyLogo"
            alt="company_logo"
            class="navbar-header-logo"
          />
        </div>
        <div class="ml-4 mt-1" v-if="knowledgeRedirection">
          <el-button @click="goToKnowledgeRedirection">
            {{ $t('mayday-web.knowledge-redirection') }}
          </el-button>
        </div>
      </div>

      <div class="d-flex align-items-center">
        <!-- ON LARGE SCREEN - FILTERS -->
        <NavBarButton
          :icon="['fas', 'filter']"
          class="d-none d-lg-flex"
          @click="focusFilter()"
        />
        <!-- ON TABLETS - CONTRIBUTION + ALERTS -->
        <NavBarButton
          :icon="['fas', 'pen']"
          class="d-none d-md-flex"
          @click="$emit('open-contribution-modal')"
        />
        <NotificationPopover class="mr-3" source="webParametric" />
        <!-- ON MOBILE : IMAGES CAROUSEL -->
        <NavBarButton
          v-if="focusIsProduct && hasPictures"
          :icon="['fas', 'images']"
          class="d-md-none"
          @click="openCarouselModal"
        />
        <!-- MENU ON TABLETS AND SMALLER-->
        <div @click="drawer = true" class="d-flex d-lg-none flex-column">
          <div class="burger-icon-line"></div>
          <div class="burger-icon-line"></div>
          <div class="burger-icon-line"></div>
        </div>
        <!-- AVATAR ON DESKTOP -->
        <MaydayWebUserAvatar
          class="d-none d-lg-flex"
          @open-feedback="$emit('open-feedback-modal')"
        />
        <!-- MOBILE DRAWER -->
        <el-drawer
          class="menu-drawer"
          title="Menu"
          :visible.sync="drawer"
          :direction="direction"
          :size="size"
        >
          <div class="row mx-0">
            <div class="col-12 justify-content-center">
              <div
                class="d-lg-none toggle-item d-flex align-items-center mobile-nav-item filter"
                @click="focusFilter()"
              >
                <div
                  class="d-flex align-items-center justify-content-center mobile-nav-icon-wrapper filter"
                >
                  <font-awesome-icon
                    :icon="['fas', 'filter']"
                    class="mobile-nav-icon"
                  />
                </div>
                <p class="mb-0">Faire une recherche filtrée</p>
              </div>
              <el-divider class="my-1 mx-auto d-lg-none col-12"></el-divider>
              <div
                class="d-md-none toggle-item d-flex align-items-center mobile-nav-item"
                @click="$emit('open-contribution-modal'), (drawer = false)"
              >
                <div
                  class="d-flex align-items-center justify-content-center mobile-nav-icon-wrapper contribution"
                >
                  <font-awesome-icon
                    :icon="['fas', 'pen']"
                    class="mobile-nav-icon"
                  />
                </div>
                <p class="mb-0">Faire une contribution</p>
              </div>
              <!-- <div class="d-lg-none toggle-item d-flex align-items-center mobile-nav-item">
                <font-awesome-icon :icon="['fas', 'sync']" class="mr-2 mobile-nav-icon" />
                <p class="mb-0">Raffraichir la connaissance</p>
              </div>-->
              <el-divider class="my-1 d-md-none mx-auto col-12"></el-divider>
              <div
                class="d-lg-none toggle-item d-flex align-items-center mobile-nav-item"
                @click="handleLogout"
              >
                <div
                  class="d-flex align-items-center justify-content-center mobile-nav-icon-wrapper sign-out"
                >
                  <font-awesome-icon
                    :icon="['fas', 'sign-out-alt']"
                    class="mobile-nav-icon"
                  />
                </div>
                <p class="mb-0">Se déconnecter</p>
              </div>
            </div>
          </div>
        </el-drawer>
      </div>
    </b-navbar>
  </div>
</template>

<script>
import MaydayWebUserAvatar from '@/layout/MaydayWeb/MaydayWebUserAvatar.vue';
import NotificationPopover from '@/components/Notifications/NotificationPopover.vue';

import NavBarButton from './NavBarButton.vue';
import { mapActions, mapGetters } from 'vuex';

export default {
  name: 'mayday-web-parametric-navbar-menu',
  components: {
    NavBarButton,
    NotificationPopover,
    MaydayWebUserAvatar,
  },
  props: {
    focusIsProduct: Boolean,
    hasPictures: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      drawer: false,
      direction: 'rtl',
    };
  },
  computed: {
    size() {
      if (window.innerWidth < 768) {
        return '100%';
      } else if (window.innerWidth <= 1279 && window.innerWidth >= 769) {
        return '50%';
      }
      return '30%';
    },
    companyDynamicStyle() {
      return {
        '--custom-color': this.companyColor,
      };
    },
    ...mapGetters(['companyLogo', 'companyColor', 'knowledgeRedirection']),
  },
  methods: {
    homeRedirection() {
      this.$router.push('/web-parametric');
    },
    focusFilter() {
      this.drawer = false;
      this.$router.push({
        path: '/web-parametric',
      });
    },
    handleLogout() {
      this.drawer = false;
      this.logout();
    },
    openCarouselModal() {
      this.$root.$emit('open-product-viewer-carousel');
    },
    goToKnowledgeRedirection() {
      const currentUrl = new URL(window.location.href);
      // TODO: fetch language from knowledge defaultLanguage
      window.open(
        `${currentUrl.origin}/desk/default/knowledges/${this.knowledgeRedirection}`,
        '_blank',
      );
    },
    ...mapActions(['logout']),
  },
};
</script>

<style lang="scss" scoped>
.menu-drawer {
  :deep() .el-drawer__header {
    color: black;
    font-size: 24px;
    font-weight: 700;
  }
}

.is-nul {
  :deep() .el-badge__content {
    display: none;
  }
}

.el-badge {
  :deep() .el-badge__content {
    top: 10px;
    right: 32px;
  }
}

.mobile-nav-icon-wrapper {
  width: 32px;
  height: 32px;
  border-radius: 4px;
  margin-right: 8px;
  &.filter {
    background: $blue-mayday;
  }
  &.contribution {
    background: $green-mayday;
  }
  &.sign-out {
    background: $red-mayday;
  }
}

.mobile-nav-item {
  min-height: 42px;
  font-size: 16px;
  padding: 16px;
  p {
    color: black;
  }
}

.filter {
  // background: rgba($blue-mayday, 0.1);
}

.mobile-nav-item {
  // border: 1px solid $grey-2-mayday;
  border-radius: 4px;
  .mobile-nav-icon {
    color: white;
  }
}

.navbar-header-logo {
  max-height: 40px;
}

.burger-icon-line {
  border: 1px solid white;
  margin: 4px 0px;
  width: 24px;
}

.toggle-icon-wrapper {
  width: 40px;
  height: 48px;
}

.mobile-navbar {
  background-color: var(--custom-color);
}

.toggle-item {
  color: $grey-5-mayday;
}

.company-brand {
  background-color: white;
  border-radius: 2px;
  padding: 4px;
  max-height: 60px;
}
</style>
